import { render, staticRenderFns } from "./onePlusSixCollect.vue?vue&type=template&id=0eb71ff6&scoped=true&"
import script from "./onePlusSixCollect.vue?vue&type=script&lang=js&"
export * from "./onePlusSixCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb71ff6",
  null
  
)

export default component.exports